import {IntegrationApiCoordinator} from './IntegrationApiCoordinator'


new IntegrationApiCoordinator()
